function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": titleId,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    color: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "homeAltIconTitle"
  }, "Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "homeAltIconTitle"
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 3 10.182 L 3 22 L 21 22 L 21 10.182 L 16.5 6.091 L 12 2 L 3 10.182 Z",
    style: {
      fill: "rgba(252, 252, 252, 0)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 9,
    y: 14,
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e24d6778bdd28dea1f3ba62ec581952b.svg";
export { ForwardRef as ReactComponent };